import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { contractApi } from '../services/api';
import type { Contract } from '../types';

/** The resolution scope is persisted with the ÄTA, independent of navigation. */
export default function ConflictVariationNotice({ contract, viewer = 'company' }: {
  contract: Contract;
  /** The buyer is told what signing means in the review panel instead of the company's hint. */
  viewer?: 'company' | 'person';
}) {
  const { t } = useTranslation();
  const [scope, setScope] = useState<Awaited<ReturnType<typeof contractApi.getConflictVariationScope>>>(null);
  useEffect(() => {
    let active = true;
    setScope(null);
    if (contract.contractType === 'variation') {
      void contractApi.getConflictVariationScope(contract.id).then(value => {
        if (active) setScope(value);
      }).catch(() => { /* This read-only notice never changes agreement content. */ });
    }
    return () => { active = false; };
  }, [contract.id, contract.contractType]);
  return scope && (
    <aside className="alert alert-info" data-testid="conflict-variation-notice">
      {/* The buyer gets the term written out, not "ÄTA". */}
      {t(viewer === 'person' ? 'conflictVariation.resolvesPerson' : 'conflictVariation.resolves', { number: scope.milestoneNumber, contract: scope.contractNumber })}
      {viewer === 'company' && <div className="small mt-1">{t('conflictVariation.companyHint')}</div>}
    </aside>
  );
}
